import { CommonRequestParams } from "@/types/commonParams";
import { APP_VERSION } from "./constant";
import { getCType, getContainerPlatform } from "./getBrowserEnv";
import { getLocationInfo } from "./location";
import { getCacheUserInfo } from "./login";
import { getUuid } from "./uuid";

export async function getCommonParams(): Promise<CommonRequestParams> {
  const userInfo = getCacheUserInfo();
  const uuid = getUuid();
  const locationInfo = await getLocationInfo();

  const { userId = "" } = userInfo || {};
  const { actualCityInfo, selectCityInfo } = locationInfo || {};

  return {
    _ver: APP_VERSION,
    platform: getContainerPlatform(),
    cityId: selectCityInfo?.cityId || null,
    userId: userId || null,
    uuid: uuid || null,
    lng: actualCityInfo?.lng || null,
    lat: actualCityInfo?.lat || null,
    osType: null,
    osVersion: null,
    addrLng: selectCityInfo?.lng || null,
    addrLat: selectCityInfo?.lat || null,
    cType: getCType(),
    token: userInfo?.token || null,
  } as CommonRequestParams;
}
